<template>
  <div class="sms" :class="smsTheme">
    <div class="label">
      <span class="title">{{smsTitle}}</span>
    </div>
    <div class="control">
      <textarea :value="smsText" @input="$emit('update:smsText', $event.target.value)" class="textarea"></textarea>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['smsTitle', 'smsText', 'smsTheme', 'isSaved']
  }
</script>

<style lang="scss" scoped>
  .sms .label {
    white-space: nowrap;
  }

  .sms .label .title {
    font-size: 16px;
  }
  .sms .label .words {
    font-size: 10px;
  }

  .sms .label .words {
    white-space: nowrap;
    overflow-x: hidden;
    display: inline;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// Sms.vue?a7fc10a4